<!-- Hack to ensure mat chip styling is imported
<button mat-flat-button
  [disableRipple]="!clickable"
  (click)="itemClick.emit()"
  *ngIf="categoryType"
  [style.color]="invertColor(categoryType.color)"
  [style.background-color]="categoryType.color"
  class="ellipsis mat-elevation-z2"
  style="max-width: 100%; width: 100%; border-radius: 25px;"
>
  <div class="ellipsis" style="max-width: 100%; width: 100%; overflow: hidden">
    <mat-icon>{{categoryType.icon}}</mat-icon>&nbsp;{{categoryType.name}}
  </div>

</button>-->

<app-button-tag
  (itemClick)="itemClick.emit()"
  *ngIf="categoryType"
  [color]="categoryType.color"
  [icon]="categoryType.icon"
  [label]="categoryType.name"
  [style]="categoryType.archived ? 'opacity: 0.2;' : ''"
>
</app-button-tag>
